import { TraceNode } from './traceNode'

export class Trace implements ITrace {

    public Tracing: Array<ITraceNode> = [];
    
    constructor(data: ITrace) {
        this._processData(data.Tracing);
    }

    public toJson() {
        return {
            Tracing: this.Tracing.map((node: ITraceNode) => {
                return node.toJson();
            })
        }
    } 

    private _processData(data:Array<ITraceNode> ) {
        data.forEach((node: ITraceNode) => {
            this.Tracing.push(new TraceNode(node));
        })
    }
} 